import { render } from "./ModalAdicionarFiltro.vue?vue&type=template&id=37bd1b32&scoped=true&ts=true"
import script from "./ModalAdicionarFiltro.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarFiltro.vue?vue&type=script&lang=ts"

import "./ModalAdicionarFiltro.vue?vue&type=style&index=0&id=37bd1b32&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bd1b32"]])

export default __exports__